import React, {Component} from 'react'
import HorizontalInfoBlock from '../HorizontalInfoBlock'
import InfoBlockGrid from '../InfoBlockGrid'
import { matchAndReturnGatsbyImage } from '../utils'
import './featured-info-block-grid.css'

const desktopWidth = 600;

class FeaturedInfoBlockGrid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      width: (typeof window !== 'undefined') ? window.innerWidth : 0,
    }

    this.updateWidth = this.updateWidth.bind(this);
  }

  componentDidMount() {
    this.updateWidth();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.updateWidth);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateWidth);
    }
  }

  updateWidth() {
    if (typeof window !== 'undefined') {
      this.setState({width: window.innerWidth});
    }
  }

  render() {
    let data = this.props.data;
    let images = this.props.images;

    if (this.state.width < desktopWidth) {
      return (
        <InfoBlockGrid
          nCellsPerRow={this.props.nCellsPerRow}
          nCellsPerRowMobile={this.props.nCellsPerRowMobile}
          data = {data}
          images = {images}></InfoBlockGrid>
      )
    }

    let featuredBlock =
      <HorizontalInfoBlock
        data={data[0]}
        fluid = {matchAndReturnGatsbyImage(images, data[0].src)}></HorizontalInfoBlock>


    let infoBlockGrid =
      <InfoBlockGrid
        nCellsPerRow={this.props.nCellsPerRow}
        nCellsPerRowMobile={this.props.nCellsPerRowMobile}
        data = {data.slice(1, data.length)}
        images = {images}></InfoBlockGrid>

    return (
      <div>
        {featuredBlock}
        {infoBlockGrid}
      </div>
    );
  }
}

export default FeaturedInfoBlockGrid
